import MechanicSearchResultsHtml from '../mechanics/templates/mechanic.search.results.html';

export function BookingRequestCtrl (
  $uibModalInstance, 
  $q, 
  $scope, 
  $translate, 
  $window,
  appointmentTypes,
  bodyTypes,
  confirm,
  contactTypes,
  messages,
  request,
  streamSearch, 
  workshopAPI
) {

  $scope.mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  $scope.appointmentTypes = appointmentTypes;
  $scope.bodyTypes        = bodyTypes;
  $scope.contactTypes     = contactTypes;
  $scope.request          = request;

  $scope.approveRequest = function () {
    $scope.request.local_start_time =
      moment($scope.request.local_start_time, 'MMMM Do YYYY, h:mm:ss a').format('YYYY-MM-DDTHH:mm:ssZ').toString();

    $uibModalInstance.close({
      message     : 'Booked',
      request     : $scope.request,
      skipApproval: false
    });
  };

  $scope.deleteRequest = function () {
    confirm.generic('Are you sure you want to delete this booking request?')
      .then(function () {
        return workshopAPI.delete('/event_request', $scope.request.id);
      }).then(function () {
        $uibModalInstance.close({
          deleted     : true,
          message     : 'Deleted',
          request     : $scope.request,
          skipApproval: true
        });
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.init = function () {
    $scope.request.local_start_time =
      $scope.request.local_start_time && $scope.request.local_start_time !== 'Invalid date' ?
        moment($scope.request.local_start_time).format('MMMM Do YYYY, h:mm:ss a') : '';
  };

  $scope.mechanicSearch = {
    list: [],
    search: function (typed) {
      var _this    = this;
      var deferred = $q.defer();

      streamSearch.search('mechanics', typed).then(function (mechanics) {
        deferred.resolve(_this.list.concat(mechanics));
      });

      return deferred.promise;
    },
    format: function (mechanic) {
      return angular.isObject(mechanic) ? mechanic.display_name: mechanic;
    },
    choose: function (mechanic) {
      $scope.request.mechanic_id           = mechanic.id;
      $scope.request.mechanic_display_name = mechanic.display_name;

      $scope.verifyAvailability();
    }
  };

  $scope.selectTime = function (event) {
    var picker = $(event.currentTarget).datetimepicker({
      showMeridian: true,
      startView   : 'month',
      startDate   : new Date(),
      disabledDates: [new Date()],
      initialDate : new Date(
        moment($scope.request.local_start_time || $scope.request.requested_date,
        $scope.request.local_start_time ? 'MMMM Do YYYY, h:mm:ss a' : 'YYYY-MM-DD'
      ).format('MMMM D, YYYY'))
    }).on('changeDate', function(ev) {

      // This datetime picker has a bug that returns UTC date instead of what was selected
      // so we need to convert it
      var date = new Date(ev.date.valueOf());

      $scope.request.local_start_time = moment(new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes()
      ).toISOString()).format('MMMM Do YYYY, h:mm:ss a');

      if (!$scope.$$phase) {
        $scope.$apply();
      }

      $(picker).datetimepicker('hide');
      $scope.verifyAvailability();
    });
    $(picker).datetimepicker('show');
  };

  $scope.updateRequest = function () {
    $scope.request.local_start_time =
      moment($scope.request.local_start_time, 'MMMM Do YYYY, h:mm:ss a').format('YYYY-MM-DDTHH:mm:ssZ').toString();

    $uibModalInstance.close({
      message     : 'Updated',
      request     : $scope.request,
      skipApproval: true
    });
  };

  $scope.verifyAvailability = function () {
    if (!!$scope.request.local_start_time && !!$scope.request.mechanic_display_name) {
      workshopAPI.post('/event_request/confirm_valid_booking_time', {
        local_start_time: moment($scope.request.local_start_time, 'MMMM Do YYYY, h:mm:ss a').format('YYYY-MM-DDTHH:mm:ssZ').toString(),
        mechanic_id: $scope.request.mechanic_id
      }).then(function () {
        // do nothing
      }, function (error) {
        messages.error(error);
      });
    }
  };

  $scope.viewDiary = function () {
    $window.open(`workshop.html#/booking-diary?view=day&group_index=0&date=${ $scope.request.requested_date }`,'_blank');
  };

  $scope.init();
}